import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { AntdModule } from '@core/config/antd.module';

export const SHARED_MODULES = [CommonModule, FormsModule, RouterModule, AntdModule];

// widgets
import { AppIconComponent } from '@components/widgets/icon/app-icon.component';
import { AppSkeletonComponent } from '@components/widgets/skeleton/app-skeleton.component';
import { AppCardComponent } from '@components/widgets/card/app-card.component';
import { AppSpinComponent } from '@components/widgets/spin/app-spin.component';
import { AppBackToTopComponent } from '@components/widgets/back-to-top/app-back-to-top.component';

export const SHARED_WIDGET_COMPONENTS = [
  AppIconComponent,
  AppSkeletonComponent,
  AppCardComponent,
  AppSpinComponent,
  AppBackToTopComponent,
];

import { AppActionComponent } from '@components/actions/app-action/app-action.component';
import { AppFieldComponent } from '@components/fields/app-field.component';
import { AppTableComponent } from '@components/tables/app-table.component';
import { AppElementComponent } from '@components/layout/element/app-element.component';
import { AppSectionComponent } from '@components/layout/section/app-section.component';
import { AppSubSectionComponent } from '@components/layout/section/app-subsection.component';
import { AppFormHeaderComponent } from '@components/layout/header/app-form-header.component';
import { AppFormErrorComponent } from '@components/layout/error-header/app-form-error.component';
import { FormLayoutComponent } from '@components/layout/form-layout/app-form-layout.component';
import { AppFormModalsComponent } from '@components/modals/app-form-modals.component';
import { StandardModalComponent } from '@components/modals/standard-modals.component';
import { UploadModalComponent } from '@components/modals/standard-modals.component';
import { ImageUploadModalComponent } from '@components/modals/standard-modals.component';

import { AppBaseFormComponent } from '@components/forms/app-base-form.component';
import { AppFormComponent } from '@components/forms/app-form.component';

export const SHARED_TUAIN_FORMS = [
  AppActionComponent,
  AppFieldComponent,
  AppTableComponent,
  AppElementComponent,
  AppSectionComponent,
  AppSubSectionComponent,
  AppFormHeaderComponent,
  AppFormErrorComponent,
  FormLayoutComponent,
  AppFormModalsComponent,
  StandardModalComponent,
  UploadModalComponent,
  ImageUploadModalComponent,
  // --------------------------
  AppBaseFormComponent,
  AppFormComponent,
];
